// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --amplify-primary-color: #005db9;\n  --amplify-primary-tint: #005db9;\n  --amplify-primary-shade: #005db9;\n}", ""]);
// Exports
module.exports = exports;
